<form [formGroup]="eligibilityForm" (ngSubmit)="onSubmit(eligibilityForm.value)">
  <div class="form-group-container">
    <div class="form-field first-name">
      <label>
        <span class="form-label">First Name</span>
        <input
          [ngClass]="{ 'error-shadow': firstNameError }"
          class="first-name-form"
          type="text"
          placeholder="Enter your first name"
          required
          formControlName="firstName"
          id="first-name" />
      </label>
    </div>
    <div class="form-field last-name">
      <label>
        <span class="form-label">Last Name</span>
        <input
          [ngClass]="{ 'error-shadow': lastNameError }"
          class="last-name-form"
          type="text"
          placeholder="Enter your last name"
          required
          formControlName="lastName"
          id="last-name" />
      </label>
    </div>
  </div>
  <div class="form-group-container dob-group">
    <div class="dob-container">
      <div class="dob-label form-label">Date of Birth</div>
      <div class="dob-inputs">
        <div class="form-field dob-month">
          <label>
            <select
              class="dob-month-form form-control"
              [ngClass]="{ placeholder: dobMonth.value == null }"
              required
              id="dob-month-form"
              formControlName="dobMonth">
              <option
                class="dropdown-content"
                *ngFor="let month of months"
                id="months"
                [value]="month.number"
                [selected]="month.name === 'Select'"
                [disabled]="month.name === 'Select'">
                {{ month.name }}
              </option>
            </select>
            <svg-icon class="dropdown-arrow" src="/assets/icons/chevron-right-nocircle.svg"></svg-icon>
          </label>
        </div>
        <div class="form-field dob-year-day">
          <label>
            <input
              [ngClass]="{ 'error-shadow': dayError }"
              class="dob-day-form"
              type="text"
              required
              maxLength="2"
              placeholder="Day"
              formControlName="dobDay" />
          </label>
        </div>
        <div class="form-field dob-year-day">
          <label>
            <input
              [ngClass]="{ 'error-shadow': yearError }"
              class="dob-year-form"
              type="text"
              required
              maxLength="4"
              id="dob-year"
              placeholder="Year"
              formControlName="dobYear"
              (blur)="blurUpdate(eligibilityForm.value)" />
          </label>
        </div>
      </div>
    </div>
    <div class="zip-container">
      <div class="form-field postal-code">
        <label>
          <span class="form-label">Zip Code</span>
          <input
            [ngClass]="{ 'error-shadow': postalError }"
            class="postal-code-form"
            type="text"
            placeholder="Zip code"
            required
            maxLength="5"
            formControlName="postalCode"
            id="postal-code" />
        </label>
      </div>
    </div>
  </div>
  <p class="error-check" *ngIf="firstNameError || lastNameError || dayError || yearError || postalError">
    <svg-icon
      src="/assets/icons/alert-circle.svg"
      [svgStyle]="{ 'width.px': 22, 'padding-bottom.px': 4, 'padding-right.px': 4 }"></svg-icon>
    <strong>Check the highlighted field for errors</strong>
  </p>
  <div class="error-container" *ngIf="firstNameError">
    <div class="error-title">
      <strong>First Name</strong>
    </div>
    <div class="error-description">First name cannot be blank.</div>
  </div>
  <div class="error-container" *ngIf="lastNameError">
    <div class="error-title">
      <strong>Last Name</strong>
    </div>
    <div class="error-description">Last name cannot be blank.</div>
  </div>
  <div class="error-container" *ngIf="dayError">
    <div class="error-title">
      <strong>Date of Birth</strong>
    </div>
    <div class="error-description">The day must have 1 or 2 digits between 01 and 31.</div>
  </div>
  <div class="error-container" *ngIf="yearError">
    <div class="error-title">
      <strong>Date of Birth</strong>
    </div>
    <div class="error-description">The year must have 4 digits. Ex. 1953.</div>
  </div>
  <div class="error-container" *ngIf="postalError">
    <div class="error-title">
      <strong>ZIP Code</strong>
    </div>
    <div class="error-description">The ZIP code must have 5 digits. Ex. 48103.</div>
  </div>
  <kp-eligibility-error *ngIf="error"></kp-eligibility-error>
  <div class="button-row" *ngIf="groupValidationBloc.groupValidationDataStatus$ | async as groupValidationStatus">
    <a
      class="button button-secondary button-pill button-eligibility"
      routerLink="/welcome/eligibility"
      *ngIf="groupValidationStatus?.data?.eligibilityVerificationTypes?.length > 1"
      (click)="switchToAnotherMethod()">
      Try Another Method
    </a>
    <button
      class="button button-pill button-eligibility"
      type="submit"
      [disabled]="!eligibilityForm.valid || loading || error">
      Continue
    </button>
  </div>
</form>
